/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { tipoEmpleoActivosGet } from '../fn/job-type/tipo-empleo-activos-get';
import { TipoEmpleoActivosGet$Params } from '../fn/job-type/tipo-empleo-activos-get';
import { tipoEmpleoDescripcionDesarrolladorWebGet } from '../fn/job-type/tipo-empleo-descripcion-desarrollador-web-get';
import { TipoEmpleoDescripcionDesarrolladorWebGet$Params } from '../fn/job-type/tipo-empleo-descripcion-desarrollador-web-get';
import { tipoEmpleoEstadoIdJobTypePatch } from '../fn/job-type/tipo-empleo-estado-id-job-type-patch';
import { TipoEmpleoEstadoIdJobTypePatch$Params } from '../fn/job-type/tipo-empleo-estado-id-job-type-patch';
import { tipoEmpleoExisteDesarroladorWebGet } from '../fn/job-type/tipo-empleo-existe-desarrolador-web-get';
import { TipoEmpleoExisteDesarroladorWebGet$Params } from '../fn/job-type/tipo-empleo-existe-desarrolador-web-get';
import { tipoEmpleoExisteIdJobTypeDesarrolladorWebGet } from '../fn/job-type/tipo-empleo-existe-id-job-type-desarrollador-web-get';
import { TipoEmpleoExisteIdJobTypeDesarrolladorWebGet$Params } from '../fn/job-type/tipo-empleo-existe-id-job-type-desarrollador-web-get';
import { tipoEmpleoGet } from '../fn/job-type/tipo-empleo-get';
import { TipoEmpleoGet$Params } from '../fn/job-type/tipo-empleo-get';
import { tipoEmpleoIdJobTypeGet } from '../fn/job-type/tipo-empleo-id-job-type-get';
import { TipoEmpleoIdJobTypeGet$Params } from '../fn/job-type/tipo-empleo-id-job-type-get';
import { tipoEmpleoIdJobTypePatch } from '../fn/job-type/tipo-empleo-id-job-type-patch';
import { TipoEmpleoIdJobTypePatch$Params } from '../fn/job-type/tipo-empleo-id-job-type-patch';
import { tipoEmpleoPost } from '../fn/job-type/tipo-empleo-post';
import { TipoEmpleoPost$Params } from '../fn/job-type/tipo-empleo-post';

@Injectable({ providedIn: 'root' })
export class JobTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tipoEmpleoGet()` */
  static readonly TipoEmpleoGetPath = '/tipo-empleo';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoGet$Response(params?: TipoEmpleoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoGet(params?: TipoEmpleoGet$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoPost()` */
  static readonly TipoEmpleoPostPath = '/tipo-empleo';

  /**
   * insert.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tipoEmpleoPost$Response(params?: TipoEmpleoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * insert.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tipoEmpleoPost(params?: TipoEmpleoPost$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoIdJobTypeGet()` */
  static readonly TipoEmpleoIdJobTypeGetPath = '/tipo-empleo/{idJobType}';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoIdJobTypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoIdJobTypeGet$Response(params: TipoEmpleoIdJobTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoIdJobTypeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoIdJobTypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoIdJobTypeGet(params: TipoEmpleoIdJobTypeGet$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoIdJobTypeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoIdJobTypePatch()` */
  static readonly TipoEmpleoIdJobTypePatchPath = '/tipo-empleo/{idJobType}';

  /**
   * update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoIdJobTypePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tipoEmpleoIdJobTypePatch$Response(params: TipoEmpleoIdJobTypePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoIdJobTypePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * update.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoIdJobTypePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tipoEmpleoIdJobTypePatch(params: TipoEmpleoIdJobTypePatch$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoIdJobTypePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoEstadoIdJobTypePatch()` */
  static readonly TipoEmpleoEstadoIdJobTypePatchPath = '/tipo-empleo/estado/{idJobType}';

  /**
   * updateStateByIdJobType.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoEstadoIdJobTypePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tipoEmpleoEstadoIdJobTypePatch$Response(params: TipoEmpleoEstadoIdJobTypePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoEstadoIdJobTypePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * updateStateByIdJobType.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoEstadoIdJobTypePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tipoEmpleoEstadoIdJobTypePatch(params: TipoEmpleoEstadoIdJobTypePatch$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoEstadoIdJobTypePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoExisteDesarroladorWebGet()` */
  static readonly TipoEmpleoExisteDesarroladorWebGetPath = '/tipo-empleo/existe/desarrolador_web';

  /**
   * existByDescription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoExisteDesarroladorWebGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoExisteDesarroladorWebGet$Response(params?: TipoEmpleoExisteDesarroladorWebGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoExisteDesarroladorWebGet(this.http, this.rootUrl, params, context);
  }

  /**
   * existByDescription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoExisteDesarroladorWebGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoExisteDesarroladorWebGet(params?: TipoEmpleoExisteDesarroladorWebGet$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoExisteDesarroladorWebGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoExisteIdJobTypeDesarrolladorWebGet()` */
  static readonly TipoEmpleoExisteIdJobTypeDesarrolladorWebGetPath = '/tipo-empleo/existe/{idJobType}/desarrollador_web';

  /**
   * existByDescriptionDiffIdJobType.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoExisteIdJobTypeDesarrolladorWebGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoExisteIdJobTypeDesarrolladorWebGet$Response(params: TipoEmpleoExisteIdJobTypeDesarrolladorWebGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoExisteIdJobTypeDesarrolladorWebGet(this.http, this.rootUrl, params, context);
  }

  /**
   * existByDescriptionDiffIdJobType.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoExisteIdJobTypeDesarrolladorWebGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoExisteIdJobTypeDesarrolladorWebGet(params: TipoEmpleoExisteIdJobTypeDesarrolladorWebGet$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoExisteIdJobTypeDesarrolladorWebGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoActivosGet()` */
  static readonly TipoEmpleoActivosGetPath = '/tipo-empleo/activos';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoActivosGet$Response(params?: TipoEmpleoActivosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoActivosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoActivosGet(params?: TipoEmpleoActivosGet$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoActivosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `tipoEmpleoDescripcionDesarrolladorWebGet()` */
  static readonly TipoEmpleoDescripcionDesarrolladorWebGetPath = '/tipo-empleo/descripcion/Desarrollador_web';

  /**
   * getByDescription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tipoEmpleoDescripcionDesarrolladorWebGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoDescripcionDesarrolladorWebGet$Response(params?: TipoEmpleoDescripcionDesarrolladorWebGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return tipoEmpleoDescripcionDesarrolladorWebGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByDescription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tipoEmpleoDescripcionDesarrolladorWebGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tipoEmpleoDescripcionDesarrolladorWebGet(params?: TipoEmpleoDescripcionDesarrolladorWebGet$Params, context?: HttpContext): Observable<any> {
    return this.tipoEmpleoDescripcionDesarrolladorWebGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
